import styled, { css } from 'styled-components';

import Minus from 'components/Icons/Minus';
import Plus from 'components/Icons/Plus';
import colors from 'utils/colors';

import { AccordionItem as AccordionItemProps } from './interfaces';

export const Wrapper = styled.div``;

export const Accordions = styled.div<{ focused: boolean }>`
  border-bottom: 3px solid ${colors.blueGrey10};
  ${({ focused }) =>
    focused
      ? css`
          outline: 2px solid ${colors.orange25};
          outline-offset: 2px;
        `
      : ''}
`;

const paddingStyle = css`
  padding: 24px 16px;
`;

const iconStyle = css`
  width: 15px;
  height: 15px;
  left: 0;
  position: absolute;
  transition: transform 0.3s, opacity 0.3s;
  box-sizing: content-box;

  &:before,
  &:after {
    box-sizing: content-box;
  }
`;

export const Header = styled.button.attrs({ type: 'button' })`
  width: 100%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;

  :visited {
    outline: none;
  }

  :hover {
    cursor: pointer;
  }
`;

export const Title = styled.div`
  ${paddingStyle}
  padding-left: 0;
  font-family: 'VIC';
  width: 100%;
  text-align: left;
  color: ${colors.blueGrey};
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
`;

export const Content = styled.div`
  ${paddingStyle}
`;

export const IconPlus = styled(Plus)`
  ${iconStyle}
`;

export const IconMinus = styled(Minus)`
  ${iconStyle}
  transform: rotate(0);
`;

export const IconGroup = styled.div`
  ${iconStyle}
  position: relative;
`;

export const AccordionItem = styled.div<AccordionItemProps>`
  ${Header} {
    border-top: 3px solid ${props => (props.active ? colors.orange : colors.blueGrey10)};
    background-color: ${props => (props.active ? colors.orange10 : colors.white)};

    :focus {
      outline: none;
      background-color: ${({ active }) => (active ? colors.orange25 : colors.blueGrey10)};
    }
  }

  ${Title} {
    color: ${props => props.active && colors.brown};
  }

  ${Content} {
    color: ${colors.blueGrey};
    opacity: ${props => (props.active ? '1' : '0')};
    max-height: ${props => (props.active ? 'auto' : '0')};
    overflow: hidden;
    padding: ${props => (props.active ? '15px' : '0 15px')};
    transition: all 0.3s;
  }

  ${IconPlus} {
    transform: rotate(-90deg);
  }

  ${IconMinus} {
    transform: rotate(-180deg);
  }
  &[data-raised='true'] {
    z-index: 1000;
    position: sticky;
    background-color: ${colors.white};
  }
`;
